import { get } from '@/httpRequest/http'

const { VUE_APP_WX_SHARE, VUE_APP_ENV } = process.env

// 测试环境统一传2，获取测试公众号星财智科技的微信APPID，生产环境传3-对应生产公众号星财
const configMap = {
    dev: 2,
    sit: 2,
    uat: 2,
    prod: 3,
}

console.log('🚀 ~ VUE_APP_ENV:', VUE_APP_ENV)
// const app_config_id = { wx6bd271c4cc988570: 1, wx1d84b11035479230: 2, wx614fc2d3c6c8dbcf: 3 }
export const getWxShareSignature = pageUrl => {
    return get(`${VUE_APP_WX_SHARE}/wxapi/v1/tick?url=${pageUrl}&app_config_id=${configMap[VUE_APP_ENV]}`)
}
